<template>
  <v-navigation-drawer
    v-model="show"
    v-lock-scroll="show"
    app
    temporary
    right
    width="650px"
    class="the-kit-items-panel"
  >
    <template v-if="item">
      <panel-header :show.sync="show">
        {{ item.name }}
      </panel-header>
      <ul class="the-kit-items-panel__list">
        <li v-for="item in item.kit_items" :key="item.sku" class="the-kit-items-panel__item">
          <img :src="item.image_url" alt="" class="the-kit-items-panel__item-image" />
          <div class="the-kit-items-panel__item-info">
            <span class="the-kit-items-panel__item-name">{{ item.name }}</span>
            <span
              v-for="attr in item.attributes"
              :key="attr.label"
              class="the-kit-items-panel__item-attribute"
            >
              {{ attr.label }}: {{ attr.value }}
            </span>
          </div>
        </li>
      </ul>
    </template>
  </v-navigation-drawer>
</template>

<script>
import PanelHeader from '@/components/PanelHeader.vue';

export default {
  name: 'TheKitItemsPanel',
  components: { PanelHeader },

  props: {
    value: {
      type: Boolean,
      required: true,
    },
    item: {
      type: Object,
      default: () => {},
    },
  },

  computed: {
    show: {
      get() {
        return this.value;
      },
      set(val) {
        this.$emit('input', val);
      },
    },
  },
};
</script>

<style scoped lang="scss">
.the-kit-items-panel {
  &::v-deep > .v-navigation-drawer__content {
    display: flex;
    flex-direction: column;
    gap: 45px;
    padding: 50px;
  }

  &__list {
    list-style: none;
    padding: 0;
    margin: 0;
  }

  &__item {
    display: flex;
    gap: 12px;
    padding: 24px 0;
    border-bottom: 1px solid #e4e4e4;
  }

  &__item-image {
    width: 90px;
    height: 90px;
    object-fit: contain;
  }

  &__item-info {
    display: flex;
    flex-direction: column;
    gap: 8px;
    flex: 1;
    color: #000;
    word-break: break-word;
    font-size: 15px;
    line-height: 20px;
  }

  &__item-name {
    font-weight: 600;
    font-size: 14px;
    color: #222;
  }

  &__item-attribute {
    font-size: 14px;
    line-height: 17px;
    color: #979797;
  }
}
</style>
